import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularSvgIconModule } from "angular-svg-icon";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { ApeAvatarComponent } from "../ape-avatar/ape-avatar.component";

/**
 * Interfaccia per definire una voce di menu
 */
export interface MenuItem {
  /** Etichetta da visualizzare per la voce di menu */
  label: string;
  /** Percorso dell'icona (SVG o PNG) */
  icon: string;
  /** Tipo di icona: 'svg' per icone SVG, 'png' per immagini, 'avatar' per avatar con iniziali */
  iconType: "svg" | "png" | "avatar";
  /** Funzione da eseguire quando la voce viene cliccata */
  command: () => void;
  /** Indica se la voce è disabilitata */
  disabled?: boolean;
  /** Indica se la voce è nascosta */
  hidden?: boolean;
  /** Classe CSS aggiuntiva per personalizzazione */
  cssClass?: string;
  /** Nome per l'avatar (obbligatorio se iconType è 'avatar') */
  firstName?: string;
  /** Cognome per l'avatar (obbligatorio se iconType è 'avatar') */
  lastName?: string;
  /** Immagine per l'avatar (opzionale) */
  image?: string;
}

/**
 * Componente per le singole voci del menu hamburger
 * Gestisce la visualizzazione di icone SVG/PNG e l'esecuzione di comandi
 */
@Component({
  selector: "ape-header-menu-item",
  standalone: true,
  host: { class: "p-1" },
  imports: [
    CommonModule, AngularSvgIconModule, TranslatePipe, ApeAvatarComponent
  ],
  templateUrl: "./ape-header-menu-item.component.html"
})
export class ApeHeaderMenuItemComponent {
  /** Configurazione della voce di menu */
  @Input({ required: true }) menuItem!: MenuItem;

  /** Evento emesso quando la voce viene cliccata */
  @Output() itemClick = new EventEmitter<MenuItem>();

  /**
   * Gestisce il click sulla voce di menu
   * Esegue il comando e emette l'evento
   */
  protected onItemClick(): void {
    if (this.menuItem.disabled) {
      return;
    }

    this.menuItem.command();
    this.itemClick.emit(this.menuItem);
  }

  /**
   * Determina se la voce è cliccabile
   * @returns true se la voce non è disabilitata
   */
  protected get isClickable(): boolean {
    return !this.menuItem.disabled;
  }
}
